import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint } from 'src/components/shared/CssValues'

const ContentsWrapper = ({ children, ...props }) => {
  return <Width {...props}>{children}</Width>
}

const Width = styled.div`
  max-width: 990px;
  padding: 0 20px;
  margin: auto;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: 0 30px;
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0 40px;
  }
  @media screen and (min-width: ${BreakPoint.LAPTOP}) {
    padding: 0 50px;
  }
`

export default ContentsWrapper
